<template>
  <div>
    <QS-h4-title title="核算结果"/>
    <QS-column-box :column="4" separator=":">
      <div>抵扣运营流水:<span>{{toFixed2(operationFlowDeduct)}}元</span></div>
      <div>应退押金:<span>{{toFixed2(returnDepositCpt)}}元</span></div>
      <div>应退租金:<span>{{toFixed2(returnCarAmountCpt)}}元</span></div>
      <div>需补欠款:<span>{{toFixed2(needAmountCpt)}}元</span></div>
      <!-- <div>司机补款金额:<span>{{toFixed2(needAmountCpt)}}</span></div>
      <div>需退司机金额:<span>{{toFixed2(needPay)}}</span></div> -->
    </QS-column-box>
  </div>

</template>
<script>
export default {
  inject: ['settleDetail'],
  props: {
    settleData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    settleData: {
      handler(val) {
        if (!val) return
        const data = ['receivableAmount',
          'toBeReceivedAmount',
          'receivedDeposit',
          'isSettlementRefund',
        ]
        data.forEach((key) => {
          this.setItemVal(key, val[key])
        })
      },
      immediate: true,
      deep: true,
    },
    sum: {
      handler(val) {
        this.$emit('settleResultUpdated', val)
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      receivableAmount: 0,
      toBeReceivedAmount: 0,
      receivedDeposit: 0,
      isSettlementRefund: 0,
      payItemsSum: 0,
      operationFlowAmount: 0,
    }
  },
  computed: {
    // 2. 需补租金：应收租金 - 已收租金 > 0 ? 计算后的值 : 0
    needCarAmountCpt() {
      const amount = this.receivableAmount - this.toBeReceivedAmount
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 3. 剩余应退押金：已收押金 - 需补租金 > 0 ? 计算后的值 : 0
    residueReturnDepositCpt() {
      const amount = this.receivedDeposit - this.needCarAmountCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    residueReturnDepositCptWithoutReceivedDeposit() {
      const amount = 0 - this.needCarAmountCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 4. 应退押金：剩余应退押金 - 支付款项 > 0 ? 计算后的值 : 0
    returnDepositCpt() {
      // 是否平移，平移则已收押金this.receivedDeposit不参与扣除
      const residueReturnDepositCpt = this.settleDetail?.transferredDeposit === 1 ? this.residueReturnDepositCptWithoutReceivedDeposit : this.residueReturnDepositCpt
      const amount = residueReturnDepositCpt - this.payItemsSum
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    // 5. 剩余支付款项：支付款项 - 剩余应退押金 > 0 ? 计算后的值 : 0
    residuePaymentAmountCpt() {
      const amount = this.payItemsSum - this.residueReturnDepositCpt
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    /**
     * 6. 应退租金：
     *      a.是否结算应退租金(是) => 已收租金 - 应收租金 - 剩余支付款项 > 0 ? 计算后的值 : 0
     *      b.是否结算应退租金(否) => 0
     */
    returnCarAmountCpt() {
      const amount = this.isSettlementRefund ? this.toBeReceivedAmount - this.receivableAmount - this.residuePaymentAmountCpt : 0
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    /**
     * 7. 需补欠款：
     *      a.是否结算应退租金(是) => 支付款项 - 已收押金 - (已收租金 - 应收租金) > 0 ? 计算后的值 : 0
     *      b.是否结算应退租金(否) => 已收租金 - 应收租金 < 0 ? 直接走 条件 a : (支付款项 - 已收押金 ? 计算后的值 : 0)
     */
    needAmountCpt() {
      // 是否平移，平移则已收押金this.receivedDeposit不参与扣除
      const receivedDeposit = this.settleDetail?.transferredDeposit === 1 ? 0 : this.receivedDeposit
      const aCount = this.payItemsSum - receivedDeposit - (this.toBeReceivedAmount - this.receivableAmount)
      let amount = 0
      if (this.isSettlementRefund) {
        amount = aCount
      } else if (this.toBeReceivedAmount - this.receivableAmount < 0) {
        amount = aCount
      } else {
        amount = this.payItemsSum - receivedDeposit
      }
      amount -= this.operationFlowDeduct // 减去抵扣运营流水
      return amount > 0 ? Number(amount.toFixed(2)) : 0
    },
    /** *
      8.抵扣运营流水
            a.是否结算应退租金(是) => 运营流水 - 支付款项-  已收押金-(已收租金 - 应收租金)  > 0 ? 支付款项-(已收租金 - 应收租金)   : 运营流水
            b.是否结算应退租金(否) => 运营流水 - 已收押金- 剩余支付款项
    */
    operationFlowDeduct() {
      // 是否平移，平移则已收押金this.receivedDeposit不参与扣除
      const receivedDeposit = this.settleDetail?.transferredDeposit === 1 ? 0 : this.receivedDeposit
      const num = (this.operationFlowAmount && Number(this.operationFlowAmount)) || 0
      // 支付款项- 已收押金-(已收租金 - 应收租金)
      const aCount = this.payItemsSum - receivedDeposit - (this.toBeReceivedAmount - this.receivableAmount)
      let amount = 0
      // 是否应退租金
      if (this.isSettlementRefund) {
        amount = aCount
      }
      if (!this.isSettlementRefund) {
        // 已收租金 - 应收租金
        if (this.toBeReceivedAmount - this.receivableAmount < 0) {
          amount = aCount
        } else {
          // 支付款项 - 已收押金
          amount = this.payItemsSum - receivedDeposit
        }
      }
      // 抵扣运营流水 = 运营流水 - 最终款项>0 ? 最终款项 : 运营流水
      const data = num - amount > 0 ? amount : num
      return data > 0 ? Number(data.toFixed(2)) : 0
    },
    sum() {
      return {
        returnDepositCpt: this.returnDepositCpt || '0.00',
        returnCarAmountCpt: this.returnCarAmountCpt || '0.00',
        needAmountCpt: this.needAmountCpt || '0.00',
        operationFlowDeduct: this.operationFlowDeduct || '0.00',
      }
    },
  },
  methods: {
    toFixed2(num) {
      return num.toFixed(2)
    },
    // 设置某一项得到值
    setItemVal(key, val) {
      this[key] = val
    },
    // 获取结算结果
    getSum() {
      return {
        returnDepositCpt: this.returnDepositCpt || '0.00',
        returnCarAmountCpt: this.returnCarAmountCpt || '0.00',
        needAmountCpt: this.needAmountCpt || '0.00',
        operationFlowDeduct: this.operationFlowDeduct || '0.00',
      }
    },
  },
}
</script>
